import script from "./UserManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManagementView.vue?vue&type=script&setup=true&lang=js"

import "./UserManagementView.vue?vue&type=style&index=0&id=f2460be6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2460be6"]])

export default __exports__